import { cn } from '@/app/utils/cn';
import { cnva } from '@/app/utils/cnva';

/**
 * Style for the dropdown icon in a <select> element.
 */
export const selectDropdownIconStyled = cnva(
  'transition-color pointer-events-none',
  {
    variants: {
      theme: {
        light:
          'text-gray-200 group-focus-within:text-gray-800 group-hover:text-gray-800',
        dark: 'text-gray-400 group-focus-within:text-gray-50 group-hover:text-gray-50',
      },
      error: {
        true: 'text-crimson-500 group-hover:text-crimson-500 group-focus-within:text-crimson-500',
      },
      disabled: {
        true: 'text-gray-300',
      },
    },
  }
);

/**
 * Text color class for a placeholder inside a <select> element.
 */
export const selectPlaceholderTextStyled = cnva('transition-color', {
  variants: {
    theme: {
      light: 'text-gray-400',
      dark: 'text-gray-400',
    },
    error: {
      true: '',
    },
    disabled: {
      true: 'disabled:text-gray-400',
    },
  },
});

export const SelectNativeOptionStyles = cn(
  'bg-white text-gray-900 disabled:text-gray-400'
);

export const SelectNativeOptionGroupStyles = cn('bg-white text-gray-700');
